export const STACKED_AREA_FILL_OPACITY = 0.7;
export const TOTAL_AREA_FILL_OPACITY = 0.2;
export const TOTAL_AREA_LINE_OPACITY = 1;
